<!--完善资料-->
<template>
  <div id="userInfo">
    <!--<form id="uploadForm" enctype="multipart/form-data">-->
    <!--<input id="file" type="file" name="file"/>-->
    <!--<button id="upload" type="button">upload</button>-->
    <!--</form>-->
    <!--<button @click="rrr()">提交</button>-->
    <!-- 完善资料 -->
    <div class="zwcWidth banner">
      <div class="label_box">
        <el-row>
          <el-col :span="24">
            <div class="grid-content bg-purple-dark">完善资料</div>
          </el-col>
        </el-row>
        <el-form :model="ruleForm2" status-icon :rules="rules2" ref="ruleForm2">
          <!-- 头像 -->
          <el-form-item>
            <el-upload class="avatar-uploader" action="https://api.peibanwan.com/pbw-interface/common/uploadFileToOSS" :limit="1" :show-file-list="false" :on-change="changeFile" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
              <img v-if="imageUrl" :src="imageUrl" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon el-border"></i>
            </el-upload>
            <!--<img src="../../../static/images/guide/banner.png" alt="" style="width: 100px; height: 100px; border-radius: 50%">-->
          </el-form-item>
          <div class="padding_b">
            <el-form-item label="昵称">
              <el-input v-model="name" clearable placeholder="输入昵称（以后可更改）" maxlength="7"></el-input>
            </el-form-item>
            <el-form-item label="性别" class="sex">
              <el-radio v-model="sex" label="1">男</el-radio>
              <el-radio v-model="sex" label="0">女</el-radio>
              （不可更改）
            </el-form-item>
            <el-form-item label="用户名">
              <el-input placeholder="输入登录用户名" v-model="username" clearable maxlength="11"></el-input>
            </el-form-item>
            <el-form-item label="设置登录密码" prop="pass">
              <el-input style="width: 209px;" type="password" v-model="ruleForm2.pass" autocomplete="off" maxlength="11"></el-input>
            </el-form-item>
            <el-form-item label="重复输入密码" prop="checkPass">
              <el-input style="width: 209px;" type="password" v-model="ruleForm2.checkPass" autocomplete="off" maxlength="11"></el-input>
            </el-form-item>
          </div>
          <el-form-item>
            <p class="enter">
              <el-button type="primary" @click="submitForm('ruleForm2')">注册</el-button>
            </p>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>


<!--JS-->
<script>
import {
  updateUserDetail
} from 'api/apis'
import $ from "jquery";
export default {
  data () {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码!"));
      } else {
        if (this.ruleForm2.checkPass !== "") {
          this.$refs.ruleForm2.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("确认密码不能为空!"));
      } else if (value !== this.ruleForm2.pass) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      imageUrl: "", //图片路径
      imageUrlData: '',
      name: "", //输入昵称
      sex: "1", //性别
      username: "", //设置用户名
      password: "", //密码
      ruleForm2: {
        pass: "",
        checkPass: ""
      },
      rules2: {
        pass: [{
          validator: validatePass,
          trigger: "blur"
        }],
        checkPass: [{
          validator: validatePass2,
          trigger: "blur"
        }]
      }
    };
  },
  methods: {
    rrr () {
      let vm = this
      console.log($('#file')[0].files[0], "5555555555555555")
      // var formData = new FormData();
      // formData.append('file', $('#file')[0].files[0]);
      // formData.append('name', '111')
      // formData.append('code', '202999')
      // formData.append('sex', '1')
      // formData.append('username', '1111111111111111')
      // formData.append('password', '111111')
      // console.log(formData)
      //
      // $.ajax({
      //   url: 'https://api.peibanwan.com/userInfo_updateUserDetail',
      //   type: 'POST',
      //   cache: false,
      //   data: formData,
      //   processData: false,
      //   contentType: false
      // }).done(function(res) {
      // }).fail(function(res) {});
    },
    changeFile (file, fileList) {
      console.log(file, "2222222222222222")
      // this.imageUrl = URL.createObjectURL(file.raw)
      // this.imageUrlData = file.raw
    },
    handleAvatarSuccess (res, file, fileList) {
      console.log(file, "iiiiiiiiiiiiiiiiii")
      this.imageUrl = file.response.data.ossFileName
      this.imageUrlData = file.response.data.ossFileName
    },
    beforeAvatarUpload (file) {
      const isJPG = file.type === 'image/jpg' || file.type === 'image/jpeg' || file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG JPEG PNG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },
    /*用户提交信息*/
    primary: function () {
      let vm = this;
      alert(111);
      console.log(vm.sex);
    },
    submitForm (formName) {
      let vm = this;
      vm.$refs[formName].validate(valid => {
        if (valid) {
          if (vm.imageUrl == "") {
            vm.$message.error("请上传头像");
            return;
          }
          if (vm.name == "") {
            vm.$message.error("用户昵称不能为空");
            return;
          }
          if (vm.username == "") {
            vm.$message.error("用户名不能为空");
            return;
          }
          if (vm.ruleForm2.pass == "") {
            vm.$message.error("请输入密码");
            return;
          }
          if (vm.ruleForm2.checkPass == "") {
            vm.$message.error("请输入确认密码");
            return;
          }
          // 完善资料
          updateUserDetail({
            uid: localStorage.getItem("pbw_user_pc_uid"),
            name: vm.name,
            sex: vm.sex,
            username: vm.username,
            password: vm.ruleForm2.checkPass,
            headImg: vm.imageUrlData,
          }).then((res) => {
            if (res.code == '000000') {
              vm.$message.success("完善成功");
              vm.$router.push('/home/personal');
            } else {
              vm.$message.error(res.msg);
            }
          })
        }
      })
      // vm.$refs[formName].validate(valid => {
      //   if (valid) {
      //     var formData = new FormData();
      //     formData.append('file', vm.imageUrlData);
      //     formData.append('name', vm.name)
      //     formData.append('code', vm.$route.query.code)
      //     formData.append('sex', vm.sex)
      //     formData.append('username', vm.username)
      //     formData.append('password', vm.ruleForm2.checkPass)
      //     console.log(formData)
      //
      //     // 上传头像表单提交
      //
      //     // $.ajax({
      //     //   url: 'https://api.peibanwan.com/pbw-interface/user/reg/updateUserDetail',
      //     //   type: 'POST',
      //     //   cache: false,
      //     //   data: formData,
      //     //   processData: false,
      //     //   contentType: false
      //     // }).done(function(res) {
      //     //   if (res.code == "000000") {
      //     //     console.log(res)
      //     //     vm.$message.success("完善资料成功，开始旅程吧！~");
      //     //     vm.$router.push("/");
      //     //   }else if(res.code == "888888"){
      //     //     vm.$message.success("您已经完善资料成功，不需要完善！~");
      //     //     vm.$router.push("/");
      //     //   } else {
      //     //     console.log(typeof(res))
      //     //     vm.$message.error(JSON.parse(res).msg);
      //     //   }
      //     //
      //     // }).fail(function(res) {
      //     //
      //     // });
      //
      //   } else {
      //     console.log("error submit!!");
      //     return false;
      //   }
      // });
    }
  },
  updated: function () { }
};
</script>


<!--css样式-->
<style lang="scss" scoped>
@import '../../../src/scss/commonH5.scss';
@import '../../scss/demo.scss';
.el-border {
  border-radius: 50%;
  width: 150px;
  height: 150px;
  line-height: 150px;
  border: 1px solid #ddd;
  text-align: center;
}
.avatar {
  border-radius: 50%;
  width: 150px;
  height: 150px;
}
#userInfo {
  text-align: center;
}
/* 完善资料 */
.banner {
  background: url(../../../static/images/title/login.jpg) no-repeat;
  background-size: 100% 100%;
  width: 100%;
  padding: 45px 0;
}
.banner .label_box {
  background-color: #ffffff;
  width: 365px;
  margin: auto;
  padding: 35px 40px;
}
.label_box .grid-content {
  text-align: left;
  font-size: 22px;
  color: #828282;
  margin-bottom: 10px;
}
.label_box .padding_b {
  padding: 0 30px;
}
.label_box .el-input {
  position: relative;
  font-size: 14px;
  display: inline-block;
  width: 237px;
}
.label_box input.el-input__inner {
  border: 0;
  font-size: 16px;
  padding: 0 5px;
}
.padding_b .el-form-item__content {
  border-bottom: 1px solid #f7f7f7;
}
.padding_b .el-form-item__label {
  color: #b3b3b5;
}
.padding_b .sex .el-form-item__content {
  position: relative;
  left: -50px;
}
</style>




// WEBPACK FOOTER //
// src/views/login/userInfo.vue